import api from "./axios";

export type EvaluacionRow = {
  reservaId: number;
  fecha: string;
  alumnoId: number;
  profesorId: number;
  asignaturaId: number;
  centroId: number | null;
  proyecto: string;
  puntualidad?: number;
  motivacion?: number;
  atencion?: number;
  deberes?: number;
  nivel?: number;
  media?: number;
  observaciones?: string | null;
};

export type SearchResponse = {
  rows: EvaluacionRow[];
  total: number;
  page: number;
  pageSize: number;
};

export async function getEvaluacionesSearch(params: Record<string, any>) {
  const { data } = await api.get<SearchResponse>("/evaluaciones/search", {
    params,
  });
  return data;
}

export async function getEvaluacionesResumen(params: Record<string, any>) {
  const { data } = await api.get<{ groupBy: string; rows: any[] }>("/evaluaciones/resumen", {
    params,
  });
  return data;
}

export async function getFirstClassDate(alumnoId: number) {
  const { data } = await api.get<{ firstDate: string | null }>(
    `/evaluaciones/alumno/${alumnoId}/first-class-date`
  );
  return data.firstDate;
}
